export default __webpack_public_path__ + "fonts/loan-geek-logo-mark.svg";